import { ScheduleSearchResults } from "./components/SearchResults";
import { ScheduleSearchAutocompleteArrowsHandling } from './components/AutocompleteArrowsHandling';
import { hightlightAutocompleteSearchPart } from "./components/helpers";
import { config } from "./components/config";

const ScheduleSearchComponent = () => {
    const schedulesSearchResults = ScheduleSearchResults();

    return {
        searchTerm: "",
        open: false,
        loading: false,
        selected: undefined,
        searchDebounceTimeout: undefined,
        results: [],
        resultsTotal: schedulesSearchResults.getTotalResultsCount(),
        resultsSearchedCount: 0,
        searchedResultsCount: 0,

        initialize() {
            schedulesSearchResults.initialize();
            this.$watch('searchTerm', () => this.handleSearchInputChange());
        },

        handleFormSubmit(event) {
            event.preventDefault();
        },

        handleSearchInputChange() {
            this.open = true;
            this.loading = true;
            this.results = [];
            if (this.searchDebounceTimeout) clearTimeout(this.searchDebounceTimeout);
            this.searchDebounceTimeout = setTimeout(() => {
                this.loadSuggestions();
            }, config.scheduleSearchTimeout);
        },

        loadSuggestions() {
            const cleanSearchTerm = this.searchTerm.trim();
            if (!cleanSearchTerm.length) {
                this.loading = false;
                this.close();
                this.clearSelected();
                return;
            }

            const action = this.$refs.form.getAttribute("action") + ".json";
            return fetch(action + "?q=" + encodeURIComponent(cleanSearchTerm))
                .then((response) => response.json())
                .then((json) => {
                    this.results = hightlightAutocompleteSearchPart(cleanSearchTerm, json);
                    this.resultsSearchedCount = this.results.length;
                    return this.results;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        selectSuggestion(suggestionItem) {
            this.selected = suggestionItem;
            this.searchTerm = this.selected.name;
            this.results = [];
            this.arrowsSelected = undefined;
            this.open = false;
            schedulesSearchResults.displayResults(this.selected.identifier);
            schedulesSearchResults.updateBadgesCount();
            this.searchedResultsCount = schedulesSearchResults.getResultsCount();
        },
        close() {
            this.open = false;
        },
        clearSelected() {
            this.searchTerm = "";
            this.open = false;
            this.results = [];
            this.selected = undefined;
            schedulesSearchResults.clearResults();
        },

        ...ScheduleSearchAutocompleteArrowsHandling(),
    };
};

window.scheduleSearch = ScheduleSearchComponent;
